module.exports = __webpack_public_path__ + "static/BigwolfA-4f95f219d405415810798610b6291029.gif";